import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { UserService } from 'gw-capability-gateway';
import hoistNonReactStatic from 'hoist-non-react-statics';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component, useContext } from 'react';
import SelectProducerCodeMessages from './SelectProducerCode.messages';

export const ProducerContext = React.createContext({
    producerCode: 'all',
    setProducerCode: () => {},
});
class SelectProducerCodeContextProvider extends Component {
    static propTypes = {
        children: PropTypes.shape({}).isRequired,
        authHeader: PropTypes.shape({}),
    };

    state = {
        producerCodeList: [],
        unSortedProducerCodeList: [],
        producerCode: 'all',
        setProducerCode: producerCode => {
            this.setState({ producerCode });
        },
    };

    componentDidMount() {
        //this.getProducerCode();
    };

    // US26481 - Load producer codes after update with auth header
    componentDidUpdate() {
        const pcList = _.get(this, 'state.producerCodeList');
        if (_.get(this, 'props.authHeader') && (!pcList || pcList.length == 0)) {
            this.getProducerCode();
        }
    };

    getProducerCode = async () => {
        const { authHeader } = this.props;
        const workStartedByMe = {
            code: 'myWork',
            name: SelectProducerCodeMessages.workStartedByMe,
        };
        const everything = {
            code: 'all',
            name: SelectProducerCodeMessages.everything,
        };
        const availableProducerCode =
            await UserService.getAvailableProducerCodesForCurrentUser(
                authHeader
            );
        const codeList = _.sortBy(
            availableProducerCode.filter( producerCode => !_.isUndefined(producerCode?.displayValue) ).map(codes => { // DE18356
                const availableProducerCodesforUser = {
                    code: codes.code,
                    name: codes.displayValue,
                };
                return availableProducerCodesforUser;
            }),
            o => o.code
        );
        const producerCodeList = [workStartedByMe, everything, ...codeList];
        this.setState({
            producerCodeList,
            unSortedProducerCodeList: availableProducerCode,
        });
    };

    render() {
        const { children } = this.props;
        const {
            unSortedProducerCodeList,
            producerCodeList,
            producerCode,
            setProducerCode,
        } = this.state;

        // DE18747
        const URLs = ["/fwUserSelfActivation","/activationlink","/logout"]

        return (
            (producerCodeList.length>0 || 
                URLs.includes(_.get(children,'props.history.location.pathname')) || 
                _.get(children,'props.history.location.pathname').includes('/new-agent'))? 
            <ProducerContext.Provider
                value={{
                    unSortedProducerCodeList,
                    producerCodeList,
                    producerCode,
                    setProducerCode,
                }}
            >
                {children}
            </ProducerContext.Provider> : null
        );
    }
}

function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
export function withProducerContext(WrappedComponent) {
    function WithProducerContext(props) {
        const producerProps = useContext(ProducerContext);
        return <WrappedComponent {...producerProps} {...props} />;
    }
    hoistNonReactStatic(WithProducerContext, WrappedComponent);
    WithProducerContext.displayName = `WithProducerContext(${getDisplayName(
        WrappedComponent
    )})`;
    return WithProducerContext;
}
export const SelectProducerContextProvider = withAuthenticationContext(
    SelectProducerCodeContextProvider
);
export default ProducerContext.Consumer;
